<template>
  <div class="c-movie__items">
    <div class="c-movie__items__col">
      <router-link :to="movieLink" class="c-link c-link--movie" :title="item.Title">
        <!--<img :src="require(`@/assets/images/${item.imageUrl}`)" alt="" class="c-movie__image">-->
        <img
          v-lazy="imageUrl || require(`@/assets/images/yesterday.jpg`)"
          alt=""
          class="c-movie__image"
        />
      </router-link>
    </div>
    <div class="c-movie__items__col c-movie__desc">
      <movie-info :showTrailer="true" :movie-detail="item"></movie-info>
      <div class="c-movie__desc__col">
        <router-link
          :to="{ name: 'booking', params: { title: item.Slug } }"
          class="c-btn c-btn--buy"
          title="Book Tickets"
        >
          Book Tickets
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import MovieInfo from '@/components/movie-info';
export default {
  name: 'movie-item',
  components: { MovieInfo },
  props: {
    item: Object
  },
  computed: {
    imageUrl() {
      const imageUrl = this.item.ImageUrl;
      return (
        (imageUrl && imageUrl.includes('.') && imageUrl) ||
        'https://pruneyardcinemas.com/wp-content/uploads/2019/11/default-image.jpg'
      );
    }
  },
  data() {
    return {
      movieLink: 'movie/' + this.item.Slug.replace("'", '%27')
    };
  }
};
</script>
